import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { mealsAPI } from '../../services/meals.api';
import { format } from 'date-fns';

const MealLog = () => {
  const [mealHistory, setMealHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMealHistory = async () => {
      try {
        setLoading(true);
        const response = await mealsAPI.getMealHistory();
        
        // Group meals by date
        const groupedMeals = response.data.reduce((acc, meal) => {
          const date = format(new Date(meal.date), 'yyyy-MM-dd');
          if (!acc[date]) {
            acc[date] = [];
          }
          acc[date].push(meal);
          return acc;
        }, {});

        setMealHistory(groupedMeals);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchMealHistory();
  }, []);

  if (loading) {
    return <div className="loading">Loading meal history...</div>;
  }

  if (error) {
    return <div className="error-message">Error: {error}</div>;
  }

  return (
    <div className="container">
      <h1>Your Meal Timeline</h1>
      <div className="timeline">
        {Object.entries(mealHistory).map(([date, meals]) => (
          <div key={date} className="timeline-item">
            <div className="card">
              <h2>{format(new Date(date), 'EEEE, MMMM d, yyyy')}</h2>
              <div className="meal-list">
                {meals.map((meal) => (
                  <div key={meal._id} className="meal-card">
                    <div className="meal-card-content">
                      <h3 className="meal-card-title">
                        {meal.meal.name}
                      </h3>
                      <div className="meal-meta">
                        <span className="meal-type">{meal.mealType}</span>
                        {meal.customTags?.map((tag) => (
                          <span key={tag} className="meal-tag">
                            {tag}
                          </span>
                        ))}
                      </div>
                      {meal.notes && (
                        <p className="meal-notes">{meal.notes}</p>
                      )}
                      <div className="meal-tags">
                        {meal.meal.dietaryType.map((type) => (
                          <span key={type} className="meal-tag">
                            {type}
                          </span>
                        ))}
                        {meal.meal.cuisineStyle.map((style) => (
                          <span key={style} className="meal-tag">
                            {style}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MealLog;
